export class Time
{
    public readonly hour: number;

    public readonly minute: number;

    public readonly second: number;

    public constructor(
        hour: number,
        minute: number,
        second: number
    )
    {
        this.hour = hour;
        this.minute = minute;
        this.second = second;
    }
}
